const liveSearchInput = (
  text: string,
  state: string,
  setState: (text: string) => void,
  timer: ReturnType<typeof setTimeout>,
  startTyping: () => void,
  stopTyping: () => void,
) => {
  startTyping();
  if (timer) {
    clearTimeout(timer);
  }

  timer = setTimeout(() => {
    setState(text);
    setTimeout(stopTyping, 1000);
  }, 1500);
};
export default liveSearchInput;
